import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { TooltipModule as PrimeNgTooltipModule } from 'primeng/tooltip';

@NgModule({
    imports: [
        CommonModule,
        PrimeNgTooltipModule,
        TooltipComponent
    ],
    exports: [TooltipComponent],
    providers: [],
})
export class TooltipModule { }
